import { useState } from 'react';

type Props = { text: string };

export function ExportActions({ text }: Props) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className="flex flex-wrap gap-3 my-6">
      <button type="button" className="gcm-btn gcm-btn-secondary" onClick={copy}>
        {copied ? 'Copied' : 'Copy plan to clipboard'}
      </button>
    </div>
  );
}
